import { Controller } from "@hotwired/stimulus";
import DOMPurify from "dompurify";

export default class extends Controller {
  static targets = ["interInput", "interTypeInput"];

  connect() {
    // Don't autload specific intervenants on edit
    if (!window.location.href.match(/edit/)) {
      const eeIdInput = document.getElementById(
        "work_permit_mode_operatoire_id"
      );
      this.loadIntervenants({ target: eeIdInput });
    }
    // this.addInterTarget.click();
  }

  buildInterOptions(results) {
    const mappedOptions = results
      .map((inter) => {
        return `
          <option value="${DOMPurify.sanitize(
            inter.id
          )}" data-type="${DOMPurify.sanitize(
          inter.class_name
        )}">${DOMPurify.sanitize(inter.name)}</option>
        `;
      })
      .join("\n");
    return mappedOptions;
  }

  loadIntervenants = (event) => {
    const moId = event.target.value;
    // Change this route to make it return a polymorphic array of both
    // IntervenantMos and IntervenantStMos, with both type and id
    // Then fill both the select tag and the hidden type field
    const path = `/mode_operatoires/${moId}/intervenant_mos.json`;
    let that = this;
    $.get(path)
      .done((results) => {
        this.interInputTargets.forEach((interInput) => {
          // Keep already selected options after loading new intervenants
          const selectedIndex = interInput.selectedIndex;
          interInput.innerHTML = this.buildInterOptions(results);
          interInput.selectedIndex = selectedIndex;
          that.updateType({ target: interInput });
        });
      })
      .fail((err) => (target.innerHTML = ""));
  };

  updateType(event) {
    const cocoonId = event.target.name.match(/\[(\d*)\]/)[1];
    const input = this.interTypeInputTargets.find((typeInput) =>
      typeInput.name.match(cocoonId)
    );
    input.value = event.target.selectedOptions[0].dataset.type;
  }
}
